import { observable, action, runInAction } from 'mobx';
import autobind from 'autobind-decorator';
import Url from '../constants/environment';

@autobind
class CommonStore {
  constructor() {}

  @observable
  isAdminIP = false;

  @action
  setIsAdminIP(value) {
    runInAction(() => {
      this.isAdminIP = value;
    });
  }

  openCaster(sportsId, gameId) {
    window.open(
      `${Url.casterWebURL}new_score_center/game_form/game_form.html?mode=update&gameId=${gameId}&sportsId=${sportsId}`,
      ``,
      'width=1200px,height=800px,scrollbars=yes'
    );
  }
  openCasterOld(sportsId, gameId) {
    window.open(
        `${Url.casterWebURL}scorecenter/gameform/gameform.html?mode=update&gidx=${gameId}&gtype=${sportsId}`,
        ``,
        'width=1200px,height=800px,scrollbars=yes'
    );
  }
}

export default CommonStore;
